import './PortalOrders.css'
import React, { useState, useEffect, } from "react";
import {faEye, faEyeSlash, faTimes, faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Modal from "../modal/Modal";
import i18n from "../i18n";
import ProductItemPortal from "../product-item-portal/ProductItemPortal";

function PortalOrders(props) {

    const [showConfirm, setShowConfirm] = useState(false);
    const [showBasketToast, setShowBasketToast] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);

    function confirmAddToCart() {
        props.setCportalBasketOrder(selectedOrder);
        props.hideCportalOrder(selectedOrder);
        setShowConfirm(false);
        setShowBasketToast(true);

        setTimeout(() => {
            setShowBasketToast(false);
        }, 3000)
    }
    return (
        <div className='portal-orders-wrapper'>
            {
                props.orders.map((order, index) => {
                    return <div className='portal-order-item'>
                        <div className='portal-order-title'>
                            <span>{i18n.t('portal_order_received')} <b>#{order.cportal_order_id}</b></span>
                            <FontAwesomeIcon
                                icon={faTrash}
                                onClick={ () => props.hideCportalOrder(index)}
                                className='hide-order'
                                title={i18n.t('hide')}
                            />
                        </div>
                        <button className='add-to-cart' onClick={() => {
                            setSelectedOrder(index);
                            setShowConfirm(true);
                        }}>{i18n.t('add_to_cart')}</button>
                        <div className="products">
                            {
                                order.basketProducts.map((product) => {
                                    let productObject = product.product_object;
                                    let selectedVariant = null;
                                    let title = '#'+productObject.code+' '+productObject.title;
                                    let title_en = '#'+productObject.code+' '+productObject.title_en;
                                    let variant_id = product.variant_id;
                                    if(product.selectedVariant) {
                                            selectedVariant = product.selectedVariant;
                                            title += " (";
                                            title_en += " (";
                                            selectedVariant.attributes.forEach( (a) => {
                                                title += `${a.attribute_category}: ${a.value} `;
                                                title_en += `${a.attribute_category_en}: ${a.value} `;
                                            });
                                            title += " )";
                                            title_en += " )";
                                    }

                                    productObject.name = title;
                                    productObject.name_en = title_en;

                                    productObject.quantity = product.quantity
                                    return <ProductItemPortal

                                        product={productObject}
                                    />
                                })
                            }
                        </div>
                    </div>
                })
            }

            <Modal
                modalTitle={i18n.t('confirm_add_to_cart')}
                showModal={showConfirm}
                onClose={() => setShowConfirm(false)}
            >
                <div>
                    {i18n.t('by_adding_order_to_cart_your_current_cart_will_remove')}
                </div>
                <div className='d-flex justify-content-end mt-1'>
                    <button className='mr-1 btn btn-primary' onClick={confirmAddToCart}>
                        {i18n.t('add_to_cart')}
                    </button>
                    <button className='btn btn-secondary' onClick={() => setShowConfirm(false)}>
                        {i18n.t('cancel')}
                    </button>
                </div>
            </Modal>
            <div className={`toast toast-basket-change`} style={{display: showBasketToast ? 'block' : 'none'}}>
                <FontAwesomeIcon
                    icon={faTimes}
                    className="btn-close"
                    onClick={ () => setShowBasketToast(false)}
                />
                {i18n.t('basket_updated')}
            </div>
        </div>
    )

}

export default PortalOrders;